import { LinkifyOptions } from 'packages/workspace/modules/algebra/constants/linkify';
import TypeAction from './TypeAction';
import TypeNotification from './TypeNotification';
import Linkify from 'linkify-react';

export interface MessageProps {
  key?: string;
  message?: string;
  dateTime?: string | Date;
  sender?: string;
  userId?: string;
  type?: string;
  display_name: string;
  system: boolean;
  message_type: string;
  helper_text?: string;
  action_owner?: string;
  entity_id?: string;
  app_id?: string;
  task_sid?: string;
}

export const Message: React.FC<MessageProps> = (props) => {
  const { type, message, message_type, action_owner, helper_text, sender, userId, entity_id, dateTime, display_name, app_id, task_sid, system } = props;
  const msgClass = type === 'onetoone' ? 'bg-tc-1' : 'bg-tc-7';

  return (
    <>
      {message_type === 'notification' ? (
        <li className="flex flex-no-wrap justify-center" tabIndex={0} key={props?.key}>
          <div className="message__card mb-3 xs:max-w-sm md:max-w-3xl ">
            <TypeNotification text={message || ''} dateTime={dateTime} />
          </div>
        </li>
      ) : (
        <li className={sender == userId || Boolean(system) ? 'flex flex-no-wrap justify-end' : 'flex flex-no-wrap justify-start'} tabIndex={0} key={props?.key}>
          <div className="message__card mb-3 xs:max-w-sm md:max-w-3xl ">
            {(() => {
              if (message_type === 'action' && action_owner && entity_id) {
                return (
                  <TypeAction
                    message={message}
                    action_owner={action_owner}
                    helper_text={helper_text}
                    sender={sender}
                    msgClass={msgClass}
                    userId={userId}
                    entity_id={entity_id}
                    dateTime={dateTime}
                    display_name={display_name}
                    app_id={app_id}
                    task_sid={task_sid}
                  />
                );
              }
              if (!message) {
                return;
              }
              return (
                <>
                  <div className={sender === userId || Boolean(system) ? 'text-right text-xs text-tc-4' : 'text-left text-xs text-tc-4'}>
                    {sender === userId ? (
                      <>
                        <strong>{display_name}</strong> {dateTime}
                      </>
                    ) : (
                      <>
                        {dateTime} <strong>{display_name}</strong>
                      </>
                    )}
                  </div>
                  <div
                    className={
                      props.sender === props.userId || Boolean(props.system)
                        ? 'text-right bg-tc-4 text-tc-1 rounded-tr-none py-1 px-4 rounded-2xl whitespace-pre-line breakWord'
                        : 'text-left text-tc-2  rounded-tl-none py-1 px-4 rounded-2xl whitespace-pre-line breakWord' + ` ${msgClass}`
                    }
                  >
                    <Linkify options={LinkifyOptions}>{props.message}</Linkify>
                  </div>
                </>
              );
            })()}
          </div>
        </li>
      )}
    </>
  );
};
